(function($) {
    $.fn.loading = function(action: any) {
        var self = $(this);
        if (action == 'start') {
            if ($(self).attr('disabled') == 'disabled') {
                return false;
            }
            $(self).prop('disabled', true);
            $(self).attr('data-btn-text', $(self).html());

            var text = 'Aguarde';
            if ($(self).attr('data-load-text') != undefined && $(self).attr('data-load-text') != '' && $(self).attr('data-load-text') != 'null') {
                text = $(self).attr('data-load-text');
            } else if ($(self).attr('data-load-text') == 'null') {
                text = '';
            }

            $(self).html('<span class="spinner"><i class="mdi mdi-loading mdi-spin" title="button-loader"></i></span> ' + text);
            $(self).addClass('active');
        } else if (action == 'stop') {
            $(self).html($(self).attr('data-btn-text'));
            $(self).removeClass('active');
            $(self).prop('disabled', false);
        }
    };
})(jQuery);
